import React from "react";
import { Button, CardActions, CardText } from "react-md";
import RegistrationCard from "../../RegistrationCard";

const MinorQuestionnaire = ({ match, questionnaire, questions, onSubmit }) => {
  const minorIndex = match.params.index ? match.params.index : 0;
  const questionIndex = match.params.questionIndex
    ? match.params.questionIndex
    : 0;
  const question = questions ? questions[questionIndex] : null;

  const answer = answer => {
    let questionnaireAnswer = {
      [`minors/${minorIndex}/questionnaire/${questionIndex}`]: {
        ...question,
        answer
      }
    };

    const nextIndex = parseInt(questionIndex, 10) + 1;

    if (nextIndex < questions.length) {
      questionnaireAnswer.nextStep = `minors/${minorIndex}/questionnaire/${nextIndex}`;
    }

    onSubmit(questionnaireAnswer);
  };

  return (
    <RegistrationCard
      title="Minor Questionnaire"
      subtitle="Please answer the following questions for the minor."
    >
      {question &&
        <div>
          <CardText>
            <div className="md-grid">
              <h2
                style={{ textAlign: "center" }}
                className="md-cell md-cell--12 md-display-1"
              >
                {question.text}
              </h2>
            </div>

            <h3 style={{ textAlign: "center" }}>
              {parseInt(questionIndex, 10) + 1} of {questions.length}
            </h3>
          </CardText>
          <CardActions>
            <Button
              raised
              label="Yes"
              primary
              className="md-cell--left"
              onClick={() => answer(true)}
            />
            <Button
              raised
              label="No"
              secondary
              className="md-cell--right"
              onClick={() => answer(false)}
            />
          </CardActions>
        </div>}

    </RegistrationCard>
  );
};

MinorQuestionnaire.propTypes = {};
MinorQuestionnaire.defaultProps = {};

export default MinorQuestionnaire;



// WEBPACK FOOTER //
// ./src/registration/components/Minors/MinorQuestionnaire/MinorQuestionnaire.jsx